export const shadows = {
  boxShadow: {
    xxxl: '0 50px 100px 0px rgba(0, 0, 0, 0.25)',
  },
};
